import { trackEvent } from "../trackEvent";

window.addEventListener("DOMContentLoaded", () => {
  const data = window?.dataLayer?.[0] ?? {};

  trackEvent({
    event: "generic",
    brand: data.brand ?? "none",
    brandCluster: data.brandCluster ?? "none",
    brandwebsitetype: data.brandWebsiteType ?? "none",
    context: data.context ?? "none",
    country: data.country ?? "none",
    event_type: "page_load",
    gbu_related: data.gbu_related ?? "none",
    language: data.language ?? "none",
    page_name: data.page_name ?? "none",
    page_type: data.page_type ?? "none",
    platform: data.platform ?? "none",
    region: data.region ?? "none",
    siteType: data.siteType ?? "none",
    subBrandCluster: data.subBrandCluster ?? "none",
    target: data.target ?? "none",
    therapeutical_area: data.therapeutical_area ?? "none",
  });
});
